// Vendors
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  BACKGROUND_STAY_CUSTOM_ACTION,
  BACKGROUND_SUCCESS_CUSTOM_ACTION,
} from './constants/background-log.handlers.constants';
import { VISIBILITY_CHANGE_EVENT } from './constants/background.handlers.constants';
import { REFRESH_TOKEN_PROPS } from 'constants/app.constants';
// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Types
import {
  BackgroundHandlersBuilderType,
  BackgroundHandlersReturnType,
} from './types/background.handlers.type';

const manageCustomerAgreementButtonClickEventHandler = async ({
  handleSendCustomActionEvent,
  setShowBackgroundModal,
  setError,
}: BackgroundHandlersBuilderType): Promise<void> => {
  const refreshed = sessionUtils.refreshToken(REFRESH_TOKEN_PROPS);

  await handleSendCustomActionEvent(BACKGROUND_STAY_CUSTOM_ACTION);

  if (refreshed) {
    await handleSendCustomActionEvent(BACKGROUND_SUCCESS_CUSTOM_ACTION);
    setShowBackgroundModal(false);
  } else {
    setError(AppErrorEnumeration.BACKGROUND_REFRESH_ERROR);
  }
};

const BackgroundFooterHandlers = (
  props: BackgroundHandlersBuilderType
): BackgroundHandlersReturnType => ({
  handleManageCustomerAgreementButtonClick: () =>
    manageCustomerAgreementButtonClickEventHandler(props),
});

export { BackgroundFooterHandlers };
